// HR Routes
import HrTutorialPage from "pages/hr/tutorial/hr-tutorial-page";
import HrHomePage from "pages/hr/home/hr-home-page";
import ManagePage from "pages/hr/manage-page";
import MasterPage from "pages/hr/master-page";
import SettingPage from "pages/hr/setting-page";
import ReportPage from "pages/hr/report-page";
import StaffHubPage from "pages/hr/manage/staff-hub-page";
import TeamPage from "pages/hr/manage/team-page";
import IdcardPage from "pages/hr/manage/idcard-page";
import AttendanceHubPage from "pages/hr/manage/attendance-hub-page";
import PublicHolidayHubPage from "pages/hr/manage/public-holiday-hub-page";
import TimeOffRequestsPage from "pages/hr/manage/time-off-requests-page";
import OvertimeRequestsPage from "pages/hr/manage/overtime-requests-page";
import TransactionsPage from "pages/hr/manage/transactions-page";
import SalaryPage from "pages/hr/manage/salary-page";
import StaffLoanPage from "pages/hr/manage/staff-loan-page";

import SchedulePatternsPage from "pages/hr/manage/schedule-patterns-page";
import AssetGroupPage from "pages/hr/master/asset-group-page";
import AssetItemPage from "pages/hr/master/asset-item-page";
import VendorPage from "pages/hr/master/vendor-page";
import BankAccountPage from "pages/hr/master/bank-account-page";
import InsurancePage from "pages/hr/master/insurance-page";
import FacilityPage from "pages/hr/master/facility-page";
import DeductionPage from "pages/hr/master/deduction-page";
import DepartmentsPage from "pages/hr/master/departments-page";
import PositionsPage from "pages/hr/master/positions-page";
import ShiftsPage from "pages/hr/master/shifts-page";
import OfficePage from "pages/hr/master/office-page";
import HolidaysPage from "pages/hr/master/holidays-page";
import ApprovalLinesPage from "pages/hr/master/approval-lines-page";
import TimeOffPoliciesPage from "pages/hr/master/time-off-policies-page";
import OvertimePoliciesPage from "pages/hr/master/overtime-policies-page";
import AttendanceSettingPage from "pages/hr/setting/attendance-setting-page";
import { TimeOffPoliciesProvider } from "pages/hr/master/context/TimeOffPoliciesContext";
import SalarySettingPage from "pages/hr/setting/salary-setting-page";
import FinanceReportPage from "pages/hr/report/finance-report-page";
import AssetReportPage from "pages/hr/report/asset-report-page";
import AttendanceReportPage from "pages/hr/report/attendance-report-page";
import SalaryReportPage from "pages/hr/report/salary-report-page";
import SettlementReportPage from "pages/hr/report/settlement-report-page";

// Contexts
import { AttendanceProvider } from "contexts/v1/masterData/AttendanceContext";
import { UserProvider } from "contexts/v1/masterData/UserContext";
import { SalaryProvider } from "pages/hr/manage/context/SalaryContext";
import { ScheduleProvider } from "pages/hr/manage/context/ScheduleContext";
import { SchedulePatternProvider } from "pages/hr/manage/context/SchedulePatternContext";
import { AttendanceSettingProvider } from "pages/hr/setting/context/AttendanceSettingContext";
import { SalarySettingProvider } from "pages/hr/setting/context/SalarySettingContext";
import { ShiftsProvider } from "pages/hr/master/context/ShiftsContext";
import { DepartmentsProvider } from "pages/hr/master/context/DepartmentsContext";

// Modules
import { URLS } from "utils/constants";
import PermissionMiddleware from "middleware/PermissionMiddleware";
import { Navigate } from "react-router-dom";
import {
  HR_ASSET_REPORT_PERMISSIONS,
  HR_ASSET_VIEW_PERMISSIONS,
  HR_STAFF_LOAN_VIEW_PERMISSIONS,
} from "utils/hrPermissionKeys";

export const hrRoutes = [
  {
    path: URLS.v1.HR_HOME,
    element: <HrHomePage />,
  },
  {
    path: URLS.v1.HR_TUTORIAL,
    element: <HrTutorialPage />,
  },
  {
    path: URLS.v1.HR_MANAGE,
    element: <ManagePage />,
  },
  {
    path: URLS.v1.HR_MANAGE_USER,
    element: (
      <PermissionMiddleware allowedPermissions={["hr_manage_user"]} fallback={<Navigate to={URLS.v1.NOTAUTHORIZED} replace />}>
        <UserProvider roleFilter="user_hr">
            <StaffHubPage />
        </UserProvider>
      </PermissionMiddleware>
    ),
  },
  {
    path: URLS.v1.HR_MANAGE_STAFF_DETAIL,
    element: (
      <PermissionMiddleware allowedPermissions={["hr_manage_user"]} fallback={<Navigate to={URLS.v1.NOTAUTHORIZED} replace />}>
        <UserProvider roleFilter="user_hr">
            <StaffHubPage />
        </UserProvider>
      </PermissionMiddleware>
    ),
  },
  {
    path: URLS.v1.HR_MASTER,
    element: <MasterPage />,
  },
  {
    path: URLS.v1.HR_SETTING,
    element: <SettingPage />,
  },
  {
    path: URLS.v1.HR_REPORT,
    element: <ReportPage />,
  },
  {
    path: URLS.v1.HR_MANAGE_TEAM,
    element: <TeamPage />,
  },
  {
    path: URLS.v1.HR_MANAGE_IDCARD,
    element: <IdcardPage />,
  },
  {
    path: URLS.v1.HR_MANAGE_ATTENDANCE,
    element: (
      <PermissionMiddleware allowedPermissions={["hr_manage_attendance"]} fallback={<Navigate to={URLS.v1.NOTAUTHORIZED} replace />}>
        <AttendanceHubPage />
      </PermissionMiddleware>
    ),
  },
  {
    path: URLS.v1.HR_MANAGE_ATTENDANCE_RECAP,
    element: <Navigate to={URLS.v1.HR_MANAGE_ATTENDANCE} replace />,
  },
  {
    path: URLS.v1.HR_MANAGE_PUBLIC_HOLIDAY_QUOTA,
    element: (
      <PermissionMiddleware allowedPermissions={["hr_manage_attendance"]} fallback={<Navigate to={URLS.v1.NOTAUTHORIZED} replace />}>
        <PublicHolidayHubPage />
      </PermissionMiddleware>
    ),
  },
  {
    path: URLS.v1.HR_MANAGE_PUBLIC_HOLIDAY_USE,
    element: <Navigate to={URLS.v1.HR_MANAGE_PUBLIC_HOLIDAY_QUOTA} replace />,
  },
  {
    path: URLS.v1.HR_MANAGE_SALARY,
    element: (
      <PermissionMiddleware allowedPermissions={["hr_manage_salary"]} fallback={<Navigate to={URLS.v1.NOTAUTHORIZED} replace />}>
        <UserProvider roleFilter="user_hr">
          <SalaryProvider>
            <SalaryPage />
          </SalaryProvider>
        </UserProvider>
      </PermissionMiddleware>
    ),
  },
  {
    path: URLS.v1.HR_MANAGE_STAFF_LOAN,
    element: (
      <PermissionMiddleware allowedPermissions={HR_STAFF_LOAN_VIEW_PERMISSIONS} fallback={<Navigate to={URLS.v1.NOTAUTHORIZED} replace />}>
        <StaffLoanPage />
      </PermissionMiddleware>
    ),
  },
  {
    path: URLS.v1.HR_MANAGE_SCHEDULE,
    element: <Navigate to={URLS.v1.HR_MANAGE_ATTENDANCE} replace />,
  },
  {
    path: URLS.v1.HR_MANAGE_TIME_OFF_REQUESTS,
    element: (
      <PermissionMiddleware allowedPermissions={["hr_time_off_requests"]} fallback={<Navigate to={URLS.v1.NOTAUTHORIZED} replace />}>
        <UserProvider roleFilter="user_hr">
          <TimeOffPoliciesProvider>
            <TimeOffRequestsPage />
          </TimeOffPoliciesProvider>
        </UserProvider>
      </PermissionMiddleware>
    ),
  },
  {
    path: URLS.v1.HR_MANAGE_OVERTIME_REQUESTS,
    element: (
      <PermissionMiddleware allowedPermissions={["hr_overtime_requests"]} fallback={<Navigate to={URLS.v1.NOTAUTHORIZED} replace />}>
        <UserProvider roleFilter="user_hr">
          <OvertimeRequestsPage />
        </UserProvider>
      </PermissionMiddleware>
    ),
  },
  {
    path: URLS.v1.HR_MANAGE_TRANSACTIONS,
    element: <TransactionsPage />,
  },
  {
    path: URLS.v1.HR_MANAGE_SCHEDULE_PATTERNS,
    element: (
      <PermissionMiddleware allowedPermissions={["hr_schedule_patterns"]} fallback={<Navigate to={URLS.v1.NOTAUTHORIZED} replace />}>
        <UserProvider roleFilter="user_hr">
          <SchedulePatternProvider>
            <SchedulePatternsPage />
          </SchedulePatternProvider>
        </UserProvider>
      </PermissionMiddleware>
    ),
  },
  {
    path: URLS.v1.HR_MASTER_ASSET_GROUP,
    element: (
      <PermissionMiddleware allowedPermissions={HR_ASSET_VIEW_PERMISSIONS} fallback={<Navigate to={URLS.v1.NOTAUTHORIZED} replace />}>
        <AssetGroupPage />
      </PermissionMiddleware>
    ),
  },
  {
    path: URLS.v1.HR_MASTER_ASSET_ITEM,
    element: (
      <PermissionMiddleware allowedPermissions={HR_ASSET_VIEW_PERMISSIONS} fallback={<Navigate to={URLS.v1.NOTAUTHORIZED} replace />}>
        <AssetItemPage />
      </PermissionMiddleware>
    ),
  },
  {
    path: URLS.v1.HR_MASTER_VENDOR,
    element: <VendorPage />,
  },
  {
    path: URLS.v1.HR_MASTER_BANK_ACCOUNT,
    element: <BankAccountPage />,
  },
  {
    path: URLS.v1.HR_MASTER_INSURANCE,
    element: <InsurancePage />,
  },
  {
    path: URLS.v1.HR_MASTER_FACILITY,
    element: <FacilityPage />,
  },
  {
    path: URLS.v1.HR_MASTER_DEDUCTION,
    element: <DeductionPage />,
  },
  {
    path: URLS.v1.HR_MASTER_DEPARTMENTS,
    element: <DepartmentsPage />,
  },
  {
    path: URLS.v1.HR_MASTER_POSITIONS,
    element: <PositionsPage />,
  },
  {
    path: URLS.v1.HR_MASTER_SHIFTS,
    element: <ShiftsPage />,
  },
  {
    path: URLS.v1.HR_MASTER_OFFICE,
    element: <OfficePage />,
  },
  {
    path: URLS.v1.HR_MASTER_HOLIDAYS,
    element: <HolidaysPage />,
  },
  {
    path: URLS.v1.HR_MASTER_APPROVAL_LINES,
    element: (
      <UserProvider roleFilter="user_hr">
        <ApprovalLinesPage />
      </UserProvider>
    ),
  },
  {
    path: URLS.v1.HR_MASTER_TIME_OFF_POLICIES,
    element: (
      <UserProvider roleFilter="user_hr">
        <TimeOffPoliciesPage />
      </UserProvider>
    ),
  },
  {
    path: URLS.v1.HR_MASTER_OVERTIME_POLICIES,
    element: <OvertimePoliciesPage />,
  },
  {
    path: URLS.v1.HR_SETTING_ATTENDANCE,
    element: (
      <UserProvider roleFilter="user_hr">
        <AttendanceSettingProvider>
          <AttendanceSettingPage />
        </AttendanceSettingProvider>
      </UserProvider>
    ),
  },
  {
    path: URLS.v1.HR_SETTING_SALARY,
    element: (
      <UserProvider roleFilter="user_hr">
        <SalarySettingProvider>
          <SalarySettingPage />
        </SalarySettingProvider>
      </UserProvider>
    ),
  },
  {
    path: URLS.v1.HR_REPORT_FINANCE,
    element: <FinanceReportPage />,
  },
  {
    path: URLS.v1.HR_REPORT_ASSET,
    element: (
      <PermissionMiddleware allowedPermissions={HR_ASSET_REPORT_PERMISSIONS} fallback={<Navigate to={URLS.v1.NOTAUTHORIZED} replace />}>
        <AssetReportPage />
      </PermissionMiddleware>
    ),
  },
  {
    path: URLS.v1.HR_REPORT_ATTENDANCE,
    element: <AttendanceReportPage />,
  },
  {
    path: URLS.v1.HR_REPORT_SALARY,
    element: <SalaryReportPage />,
  },
  {
    path: URLS.v1.HR_REPORT_SETTLEMENT,
    element: <SettlementReportPage />,
  },
];
